import React from 'react';
import { motion } from 'framer-motion';
import { Layers, ArrowRight } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide07Scope({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-144" data-mp="34z5xkw3evuon">
      <SlideHeader eyebrow="What Is a Trailer / Microsite?" data-id="element-145" data-mp="38yenfpvbz8ex">
        The trailer is the deeper campaign experience
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-20 max-w-6xl mx-auto w-full" data-id="element-146" data-mp="2v68g8ta5obrm">
        <div className="flex-1 space-y-8" data-id="element-147" data-mp="2zzkvicsy367p">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed" data-id="element-148" data-mp="2l93x72blwwf1">
            A trailer works like a compact interactive microsite. It covers the
            most important campaign issue in a guided, engaging format and can
            be adapted to each monthly campaign focus.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="grid grid-cols-2 gap-4" data-id="element-149" data-mp="9suq2frzsq7h">
            {['Campaign topic introduction', 'Educational content from approved assets', 'HCP choice paths', 'Key message reinforcement', 'Peer comparison', 'Final CTA'].map((module, i) => <div key={i} className="bg-[var(--surface)] p-4 rounded-xl border border-black/5 flex items-start gap-3" data-id="element-150" data-mp="2ugz8syqqgl07" data-mpi={i}>
                <Layers className="h-5 w-5 text-[var(--brand)] flex-shrink-0 mt-0.5" data-id="element-151" data-mp="tfj8bal5jy90" />
                <span className="text-sm font-semibold text-[var(--fg)]" data-id="element-152" data-mp="yevt7psgqv8y">
                  {module}
                </span>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="inline-flex items-center gap-3 bg-white border border-black/10 px-5 py-3 rounded-full shadow-sm" data-id="element-153" data-mp="177r1yth5393h">
            <span className="text-sm font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-154" data-mp="ohregb0y6226">
              Typical Length:
            </span>
            <span className="bg-[var(--brand)] text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-155" data-mp="1uxbht3hzxq8j">
              2–3 minutes
            </span>
          </motion.div>
        </div>

        {/* Microsite Flow Map */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.7
      }} className="flex-1 min-h-0 w-full bg-[var(--surface)] rounded-3xl p-8 border border-black/5 flex flex-col items-center justify-center" data-id="element-156" data-mp="2a2fnwgbvrk5i">
          <div className="w-full flex-1 min-h-0 flex items-center justify-center" data-id="element-157" data-mp="1mahclwcflosd">
            <img src="https://cdn.magicpatterns.com/uploads/p6ppG5pnhmcycdnfkHwqSz/Screenshot_2026-06-29_at_13.11.56.png" alt="Trailer / Microsite flow example" className="w-full max-h-full object-contain rounded-2xl shadow-md border border-black/10" data-id="element-158" data-mp="1hbxktfb5pis3" />
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}